import { createSlice } from "@reduxjs/toolkit";
import { userinitialState } from "../initialStates/userinitialstate";

const userSlice = createSlice({
  name: "user",
  initialState: userinitialState,
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      state.isLoggedIn = true;
      state.loggedInType = action.payload.loggedInType;
      state.userData = action.payload.userData;
      state.loading = false;
      state.token = action.payload.token;
    },
    setUserData(state, action) {
      state.userData = action.payload;
    },
    setUserFirstLogin(state, action) {
      state.userData.isFirstLogin = action.payload;
    },
    loginFailure(state, action) {
      state.isLoggedIn = false;
      state.userData = null;
      state.loading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.isLoggedIn = false;
      state.userData = null;
    },
    // Reset state to initial state
    revertUser(state) {
      Object.assign(state, userinitialState); // Or `return userinitialState;`
    },
    updateAvailableBalance(state, action) {
      if (state.userData) {
        state.userData.availableBalance = action.payload;
      }
    },
    updateUserCasinoBalance(state, action) {
      if (state.userData) {
        state.userData.casinoBalance = action.payload;
      }
    },
    updateExposureBalance(state, action) {
      if (state.userData) {
        state.userData.exposure = action.payload;
      }
    },
    setUserLoackApplications(state, action) {
      state.UserLoackApplications = action.payload;
    },
  },
});

export const {
  loginStart,
  setUserData,
  setUserFirstLogin,
  loginSuccess,
  loginFailure,
  logout,
  revertUser,
  updateAvailableBalance,
  updateUserCasinoBalance,
  updateExposureBalance,
  setUserLoackApplications,
} = userSlice.actions;
export default userSlice.reducer;
